export default __webpack_public_path__ + "static/media/plus_circle_blue.d815f6a8.svg";